import { ShieldCheck, Landmark, FileSignature, BadgeCheck } from "lucide-react";
import { SiteHeader } from "./SiteHeader";
import { VerifyForm } from "./VerifyForm";

const HERO_IMG = "/img/salone.jpg";

export const Hero = ({ settings }) => (
  <section className="relative bg-navy grain overflow-hidden" data-testid="hero-section">
    <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
    <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/90 to-navy/60" />
    <SiteHeader />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-20 sm:pt-36 pb-12 sm:pb-24 grid lg:grid-cols-[1.1fr_1fr] gap-6 sm:gap-10 lg:gap-16 items-start">
      <div className="text-white">
        <p className="rise hidden sm:block text-xs uppercase tracking-[0.3em] text-gold font-semibold">Depositi dormienti · Fondo Consap</p>
        <h1 className="rise rise-1 font-serif text-[2rem] sm:text-5xl lg:text-6xl font-semibold leading-[1.05] sm:mt-4">
          Verifica gratis se hai un <em className="text-gold not-italic font-serif italic">deposito dormiente</em> da recuperare
        </h1>
        <p className="rise rise-2 hidden sm:block text-slate-300 text-base md:text-lg mt-6 max-w-xl leading-relaxed">
          Conti, libretti e polizze inattivi da oltre 10 anni vengono devoluti allo Stato. Titolari ed eredi possono chiederne il rimborso: ce ne occupiamo noi, e ci paghi solo se recuperi.
        </p>
        <ul className="rise rise-3 hidden sm:grid grid-cols-2 gap-4 mt-10 max-w-lg">
          {[[ShieldCheck, "Nessun anticipo", "Compenso solo a buon fine"], [Landmark, "Istanza a Consap", "Gestita dallo studio"],
            [FileSignature, "Mandato online", "Firma digitale o cartacea"], [BadgeCheck, "Avvocato iscritto", settings?.ordine || "Ordine degli Avvocati"]].map(([I, t, s]) => (
            <li key={t} className="flex gap-3">
              <I className="h-5 w-5 text-gold shrink-0 mt-0.5" strokeWidth={1.5} />
              <div><p className="text-sm font-semibold">{t}</p><p className="text-xs text-slate-400">{s}</p></div>
            </li>
          ))}
        </ul>
      </div>
      <div className="rise rise-2 lg:mt-4"><VerifyForm /></div>
    </div>
  </section>
);
